import { render, staticRenderFns } from "./button-select.vue?vue&type=template&id=86103ca0&scoped=true&"
import script from "./button-select.vue?vue&type=script&lang=js&"
export * from "./button-select.vue?vue&type=script&lang=js&"
import style0 from "./button-select.vue?vue&type=style&index=0&id=86103ca0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86103ca0",
  null
  
)

export default component.exports